(function () {
  'use strict';

  function moneyFromCents(cents, format) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format) return '$' + withComma;
    return String(format)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function variantOptions(variant) {
    if (!variant) return [];
    if (variant.options && variant.options.length) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (x) {
      return x != null && x !== '';
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-smp-ready') === 'true') return;
    root.setAttribute('data-smp-ready', 'true');

    var form = root.querySelector('[data-smp-form]');
    var idInput = root.querySelector('[data-smp-id]');
    var qtyInput = root.querySelector('[data-smp-qty]');
    var qtyMinus = root.querySelector('[data-smp-qty-minus]');
    var qtyPlus = root.querySelector('[data-smp-qty-plus]');
    var priceEl = root.querySelector('[data-smp-price]');
    var compareEl = root.querySelector('[data-smp-compare]');
    var atc = root.querySelector('[data-smp-atc]');
    var amazonBlock = root.querySelector('[data-smp-amazon]');
    var offerEl = root.querySelector('[data-smp-offer]');
    var offerFill = root.querySelector('[data-smp-offer-fill]');
    var offerMsg = root.querySelector('[data-smp-offer-msg]');
    var optionBtns = Array.prototype.slice.call(root.querySelectorAll('[data-smp-option]'));
    var packRows = Array.prototype.slice.call(root.querySelectorAll('[data-smp-pack-row]'));
    var mediaMain = root.querySelector('[data-smp-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-smp-thumb]'));
    var thumbsTrack = root.querySelector('[data-smp-thumbs-track]');
    var thumbsWrap = root.querySelector('[data-smp-thumbs-wrap]');
    var thumbPrev = root.querySelector('[data-smp-thumb-prev]');
    var thumbNext = root.querySelector('[data-smp-thumb-next]');
    var thumbsVisible = parseInt(
      (thumbsWrap && thumbsWrap.getAttribute('data-thumbs-visible')) ||
        root.style.getPropertyValue('--smp-thumbs-visible') ||
        '5',
      10
    );
    if (!thumbsVisible || thumbsVisible < 1) thumbsVisible = 5;

    var minQty = parseInt(root.getAttribute('data-min-qty') || '5', 10);
    var minSpend = parseInt(root.getAttribute('data-min-spend') || '6000', 10);
    var moneyFormat = root.getAttribute('data-money-format') || '$' + String.fromCharCode(123) + '{amount}}';
    var limitsOn = root.getAttribute('data-limits-on') === 'true';
    var useQty = root.getAttribute('data-use-qty') === 'true';
    var useSpend = root.getAttribute('data-use-spend') === 'true';
    var rulesMode = root.getAttribute('data-rules-mode') || 'either';
    var progressScope = root.getAttribute('data-progress-scope') || 'cart';
    var productId = parseInt(root.getAttribute('data-product-id') || '0', 10);
    var offerIncomplete =
      root.getAttribute('data-offer-incomplete') ||
      'Spend [remaining] more to get free shipping';
    var offerComplete =
      root.getAttribute('data-offer-complete') || "You've unlocked free shipping!";
    var offerCelebrate = root.getAttribute('data-offer-celebrate') === 'true';
    var offerBurst = root.querySelector('[data-smp-offer-burst]');
    var offerWasComplete = null;
    var celebrateIcons = ['🎉', '🎊', '✨', '🥳', '🎈'];
    var reduceCelebrate = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var limitsUi = Array.prototype.slice.call(root.querySelectorAll('[data-smp-limits-ui]'));
    var productJson = root.querySelector('[data-smp-json]');
    var product = null;
    var cartSnapshot = { item_count: 0, total_price: 0, items: [] };
    var cartFetchBusy = false;
    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch (e) {
      product = null;
    }

    function cartUrl(path) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (base.slice(-1) !== '/') base += '/';
      return base + String(path || '').replace(/^\//, '');
    }

    var selectedOptions = {};
    optionBtns.forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        selectedOptions[btn.getAttribute('data-position')] = btn.getAttribute('data-value');
      }
    });

    function currentVariant() {
      if (!product || !product.variants) return null;
      if (!product.options || product.options.length === 0) {
        return product.variants[0] || null;
      }
      return (
        product.variants.filter(function (v) {
          var opts = variantOptions(v);
          return opts.every(function (opt, i) {
            var key = String(i + 1);
            if (selectedOptions[key] == null || selectedOptions[key] === '') return true;
            return String(opt) === String(selectedOptions[key]);
          });
        })[0] || null
      );
    }

    function syncMedia(variant) {
      if (!mediaMain || !variant) return;
      var image = variant.featured_image;
      if (!image) return;
      var src = image.src || image;
      if (typeof src === 'string') {
        mediaMain.removeAttribute('srcset');
        mediaMain.setAttribute('src', src);
        mediaMain.src = src;
      }
      if (image.id != null) {
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(image.id));
        });
      }
    }

    function meetsFreeShipping(qty, total) {
      if (!limitsOn) return true;
      if (!useQty && !useSpend) return true;
      var okQty = !useQty || qty >= minQty;
      var okSpend = !useSpend || total >= minSpend;
      if (useQty && useSpend) {
        return rulesMode === 'both' ? okQty && okSpend : okQty || okSpend;
      }
      return okQty && okSpend;
    }

    function buildRulesPhrase() {
      var parts = [];
      if (useQty) parts.push(minQty + '+ items');
      if (useSpend) parts.push(moneyFromCents(minSpend, moneyFormat) + '+');
      if (!parts.length) return '';
      if (parts.length === 1) return parts[0];
      return parts.join(rulesMode === 'both' ? ' and ' : ' or ');
    }

    function offerProgress(qty, total) {
      var totalN = Math.max(0, Number(total) || 0);
      var qtyN = Math.max(0, Number(qty) || 0);
      /* Bar always mirrors money progress when a $ goal exists (matches spend-more text) */
      if (minSpend > 0 && (useSpend || !useQty)) {
        return Math.min(1, totalN / minSpend);
      }
      if (useSpend && useQty && minSpend > 0 && minQty > 0) {
        var spendP = Math.min(1, totalN / minSpend);
        var qtyP = Math.min(1, qtyN / minQty);
        return rulesMode === 'both' ? Math.min(spendP, qtyP) : Math.max(spendP, qtyP);
      }
      if (useQty && minQty > 0) return Math.min(1, qtyN / minQty);
      if (minSpend > 0) return Math.min(1, totalN / minSpend);
      return 0;
    }

    function accentHex(complete) {
      try {
        var key = complete ? '--smp-offer-bar-done' : '--smp-offer-bar';
        var raw = (window.getComputedStyle(root).getPropertyValue(key) || '').trim();
        if (raw) return raw;
        raw = (window.getComputedStyle(root).getPropertyValue('--smp-accent') || '').trim();
        if (raw) return raw;
      } catch (e) {}
      return '#cf1f25';
    }

    function setOfferFill(progress, complete) {
      var pct = Math.round(Math.min(1, Math.max(0, Number(progress) || 0)) * 100);
      var color = accentHex(!!complete);
      var track = offerEl ? offerEl.querySelector('.smp__offer-track') : null;

      if (offerEl) {
        offerEl.style.setProperty('--smp-offer-pct', pct + '%');
      }
      if (track) {
        track.style.setProperty('--smp-offer-pct', pct + '%');
        track.setAttribute('data-pct', String(pct));
      }
      if (offerFill) {
        offerFill.style.setProperty('width', pct + '%', 'important');
        offerFill.style.setProperty('background', color, 'important');
        offerFill.style.setProperty('background-color', color, 'important');
        offerFill.setAttribute('aria-valuenow', String(pct));
      }
      return pct;
    }

    function fireCelebration() {
      if (!offerCelebrate || reduceCelebrate || !offerBurst) return;
      offerBurst.innerHTML = '';
      var count = 14;
      for (var i = 0; i < count; i++) {
        var bit = document.createElement('span');
        bit.className = 'smp__confetti';
        bit.textContent = celebrateIcons[i % celebrateIcons.length];
        var x = (Math.random() * 160 - 80).toFixed(1);
        var y = (Math.random() * 40 - 10).toFixed(1);
        var rot = (Math.random() * 80 - 40).toFixed(1);
        var delay = (Math.random() * 0.25).toFixed(2);
        bit.style.setProperty('--smp-cx', x + 'px');
        bit.style.setProperty('--smp-cy', y + 'px');
        bit.style.setProperty('--smp-rot', rot + 'deg');
        bit.style.animationDelay = delay + 's';
        bit.style.left = 20 + Math.random() * 60 + '%';
        offerBurst.appendChild(bit);
      }
      window.setTimeout(function () {
        if (offerBurst) offerBurst.innerHTML = '';
      }, 1600);
    }

    function maybeCelebrate(freeShip) {
      if (offerWasComplete === null) {
        offerWasComplete = freeShip;
        return;
      }
      if (freeShip && !offerWasComplete) fireCelebration();
      offerWasComplete = freeShip;
    }

    function fillOfferTemplate(template, qty, total) {
      var needSpend = Math.max(0, minSpend - total);
      var needQty = Math.max(0, minQty - qty);
      var t = String(template || '');
      t = t
        .replace(/\[remaining\]/gi, moneyFromCents(needSpend, moneyFormat))
        .replace(/\[spent\]/gi, moneyFromCents(total, moneyFormat))
        .replace(/\[goal\]/gi, moneyFromCents(minSpend, moneyFormat))
        .replace(/\[amount\]/gi, moneyFromCents(minSpend, moneyFormat))
        .replace(/\[qty_remaining\]/gi, String(needQty))
        .replace(/\[qty_current\]/gi, String(qty))
        .replace(/\[qty_spent\]/gi, String(qty))
        .replace(/\[qty_goal\]/gi, String(minQty))
        .replace(/\[qty\]/gi, String(minQty))
        .replace(/\[rules\]/gi, buildRulesPhrase());
      return t.replace(/\s{2,}/g, ' ').replace(/\s+\./g, '.').trim();
    }

    function autoOfferMessage(qty, total, freeShip) {
      if (freeShip) return fillOfferTemplate(offerComplete, qty, total);
      var needSpend = Math.max(0, minSpend - total);
      var needQty = Math.max(0, minQty - qty);
      var custom = String(offerIncomplete || '');
      var hasNewTokens = /\[remaining\]|\[qty_remaining\]|\[spent\]|\[goal\]/i.test(custom);
      if (hasNewTokens) {
        return fillOfferTemplate(custom, qty, total);
      }
      if (useSpend && useQty) {
        if (rulesMode === 'both') {
          return (
            'Spend ' +
            moneyFromCents(needSpend, moneyFormat) +
            ' more and add ' +
            needQty +
            ' more item' +
            (needQty === 1 ? '' : 's') +
            ' to get free shipping'
          );
        }
        if (needSpend <= 0) {
          return 'Add ' + needQty + ' more item' + (needQty === 1 ? '' : 's') + ' to get free shipping';
        }
        if (needQty <= 0) {
          return 'Spend ' + moneyFromCents(needSpend, moneyFormat) + ' more to get free shipping';
        }
        return (
          'Spend ' +
          moneyFromCents(needSpend, moneyFormat) +
          ' more to get free shipping'
        );
      }
      if (useSpend) {
        return 'Spend ' + moneyFromCents(needSpend, moneyFormat) + ' more to get free shipping';
      }
      if (useQty) {
        return 'Add ' + needQty + ' more item' + (needQty === 1 ? '' : 's') + ' to get free shipping';
      }
      return fillOfferTemplate(custom, qty, total);
    }

    /** Cart-wide totals, swapping this product's cart lines for the qty selected on the page. */
    function projectedTotals(variant, qty) {
      var pageTotal = (variant ? variant.price : 0) * qty;
      if (progressScope !== 'cart') {
        return { qty: qty, total: pageTotal };
      }

      var cartQty = cartSnapshot.item_count || 0;
      var cartTotal = cartSnapshot.total_price || 0;
      var existingQty = 0;
      var existingTotal = 0;
      (cartSnapshot.items || []).forEach(function (item) {
        if (productId && item.product_id === productId) {
          existingQty += item.quantity || 0;
          existingTotal += item.final_line_price != null ? item.final_line_price : item.line_price || 0;
        }
      });

      return {
        qty: Math.max(0, cartQty - existingQty) + qty,
        total: Math.max(0, cartTotal - existingTotal) + pageTotal
      };
    }

    function updateThreshold() {
      var variant = currentVariant();
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      if (qtyInput) qtyInput.value = String(qty);
      var price = variant ? variant.price : 0;
      var projected = projectedTotals(variant, qty);
      var freeShip = meetsFreeShipping(projected.qty, projected.total);

      if (priceEl && variant) {
        priceEl.textContent = moneyFromCents(price, moneyFormat);
      }
      if (compareEl) {
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = moneyFromCents(variant.compare_at_price, moneyFormat);
        } else {
          compareEl.hidden = true;
        }
      }

      root.classList.toggle('smp--limits-on', limitsOn);
      root.classList.toggle('smp--limits-off', !limitsOn);
      root.classList.toggle('smp--offer-complete', limitsOn && freeShip);
      root.classList.toggle('smp--offer-pending', limitsOn && !freeShip);
      root.classList.remove('smp--amazon-first');
      root.classList.add('smp--shopify-ready');

      if (atc) {
        var allow = !!(variant && variant.available);
        atc.disabled = !allow;
        atc.setAttribute('aria-disabled', allow ? 'false' : 'true');
      }

      limitsUi.forEach(function (el) {
        if (!limitsOn) el.hidden = true;
      });

      if (!limitsOn) {
        if (offerEl) offerEl.hidden = true;
        if (amazonBlock) amazonBlock.classList.remove('is-emphasized');
        return;
      }

      if (offerEl) {
        offerEl.hidden = false;
        offerEl.classList.toggle('is-complete', freeShip);
        offerEl.classList.toggle('is-pending', !freeShip);
        /* Fill = amount already toward goal; empty portion = remaining ($10.04 left ≈ ~83% filled) */
        var fillRatio = freeShip
          ? 1
          : minSpend > 0
            ? Math.min(1, Math.max(0, projected.total / minSpend))
            : offerProgress(projected.qty, projected.total);
        setOfferFill(fillRatio, freeShip);
        if (offerMsg) {
          offerMsg.textContent = autoOfferMessage(projected.qty, projected.total, freeShip);
        }
        maybeCelebrate(freeShip);
      }

      if (amazonBlock) {
        amazonBlock.classList.toggle('is-emphasized', !freeShip);
      }
    }

    function refreshCart(thenUpdate) {
      if (progressScope !== 'cart' || !limitsOn) {
        if (thenUpdate) updateThreshold();
        return;
      }
      if (cartFetchBusy) {
        if (thenUpdate) updateThreshold();
        return;
      }
      cartFetchBusy = true;
      fetch(cartUrl('cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          cartSnapshot = {
            item_count: cart.item_count || 0,
            total_price: cart.total_price || 0,
            items: cart.items || []
          };
        })
        .catch(function () {})
        .finally(function () {
          cartFetchBusy = false;
          if (thenUpdate !== false) updateThreshold();
        });
    }

    function selectVariant(variant) {
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      var opts = variantOptions(variant);
      optionBtns.forEach(function (btn) {
        var pos = btn.getAttribute('data-position');
        var val = btn.getAttribute('data-value');
        var selected = String(opts[parseInt(pos, 10) - 1]) === String(val);
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected) selectedOptions[pos] = val;
      });
      packRows.forEach(function (row) {
        row.classList.toggle('is-selected', String(row.getAttribute('data-variant-id')) === String(variant.id));
      });
      syncMedia(variant);
      updateThreshold();
    }

    function onOptionClick(btn) {
      selectedOptions[btn.getAttribute('data-position')] = btn.getAttribute('data-value');
      var variant = currentVariant();
      if (variant) selectVariant(variant);
      else updateThreshold();
    }

    function onPackClick(row) {
      var id = row.getAttribute('data-variant-id');
      if (!product || !product.variants) return;
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) {
          variant = product.variants[i];
          break;
        }
      }
      if (!variant) return;
      variantOptions(variant).forEach(function (opt, idx) {
        selectedOptions[String(idx + 1)] = opt;
      });
      selectVariant(variant);
    }

    function showThumb(thumb, index) {
      if (!thumb) return;
      if (typeof index !== 'number' || index < 0) {
        index = thumbs.indexOf(thumb);
      }
      var src = thumb.getAttribute('data-full');
      if (mediaMain && src) {
        mediaMain.removeAttribute('srcset');
        mediaMain.setAttribute('src', src);
        mediaMain.src = src;
      }
      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* Direct thumb clicks — more reliable than delegation alone with drag-scroll */
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (event) {
        if (thumbsTrack && thumbsTrack.getAttribute('data-did-drag') === '1') {
          event.preventDefault();
          event.stopPropagation();
          thumbsTrack.removeAttribute('data-did-drag');
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        showThumb(thumb, index);
      });
    });

    /* Event delegation for packs / qty / thumb nav */
    root.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;

      var option = t.closest('[data-smp-option]');
      if (option && root.contains(option)) {
        event.preventDefault();
        onOptionClick(option);
        return;
      }

      var pack = t.closest('[data-smp-pack-row]');
      if (pack && root.contains(pack)) {
        event.preventDefault();
        onPackClick(pack);
        return;
      }

      if (t.closest('[data-smp-qty-minus]')) {
        event.preventDefault();
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
        updateThreshold();
        return;
      }

      if (t.closest('[data-smp-qty-plus]')) {
        event.preventDefault();
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1));
        updateThreshold();
        return;
      }

      if (t.closest('[data-smp-thumb-prev]')) {
        event.preventDefault();
        shiftThumbs(-1);
        window.setTimeout(syncThumbNav, 280);
        return;
      }

      if (t.closest('[data-smp-thumb-next]')) {
        event.preventDefault();
        shiftThumbs(1);
        window.setTimeout(syncThumbNav, 280);
      }
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', updateThreshold);
      qtyInput.addEventListener('input', updateThreshold);
    }

    function shiftThumbs(dir) {
      if (!thumbs.length || !thumbsTrack) return;
      var gap = 10;
      try {
        var styles = window.getComputedStyle(thumbsTrack);
        gap = parseFloat(styles.columnGap || styles.gap) || 10;
      } catch (e) {}
      var step = thumbs[0].getBoundingClientRect().width + gap;
      var page = Math.max(1, thumbsVisible - 1) * step;
      thumbsTrack.scrollBy({ left: dir * page, behavior: 'smooth' });

      var active = thumbs.findIndex(function (t) {
        return t.classList.contains('is-active');
      });
      if (active < 0) active = 0;
      var next = Math.min(thumbs.length - 1, Math.max(0, active + dir));
      showThumb(thumbs[next], next);
    }

    function syncThumbNav() {
      if (!thumbsTrack || !thumbPrev || !thumbNext) return;
      if (thumbs.length <= thumbsVisible) {
        thumbPrev.hidden = true;
        thumbNext.hidden = true;
        return;
      }
      var maxScroll = thumbsTrack.scrollWidth - thumbsTrack.clientWidth - 2;
      thumbPrev.hidden = false;
      thumbNext.hidden = false;
      thumbPrev.disabled = thumbsTrack.scrollLeft <= 2;
      thumbNext.disabled = thumbsTrack.scrollLeft >= maxScroll;
    }

    function enableDragScroll(el) {
      if (!el) return;
      var active = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;
      var pointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        /* Allow normal clicks on thumb buttons — only drag the track */
        if (e.target && e.target.closest && e.target.closest('[data-smp-thumb]')) {
          return;
        }
        active = true;
        moved = false;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        pointerId = e.pointerId;
        el.removeAttribute('data-did-drag');
        try {
          el.setPointerCapture(pointerId);
        } catch (err) {}
      });

      el.addEventListener('pointermove', function (e) {
        if (!active) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 6) {
          moved = true;
          el.classList.add('is-dragging');
          el.setAttribute('data-did-drag', '1');
          el.scrollLeft = startScroll - dx;
        }
      });

      function endDrag() {
        if (!active) return;
        active = false;
        el.classList.remove('is-dragging');
        if (pointerId != null) {
          try {
            el.releasePointerCapture(pointerId);
          } catch (err) {}
        }
        pointerId = null;
        syncThumbNav();
        if (moved) {
          window.setTimeout(function () {
            el.removeAttribute('data-did-drag');
          }, 80);
        }
      }

      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);
      el.addEventListener('lostpointercapture', endDrag);
    }

    enableDragScroll(thumbsTrack);

    if (thumbsTrack) {
      thumbsTrack.addEventListener('scroll', syncThumbNav, { passive: true });
      window.addEventListener('resize', syncThumbNav);
      syncThumbNav();
    }

    var initial = currentVariant() || (product && product.variants && product.variants[0]);
    if (initial) selectVariant(initial);
    else updateThreshold();

    refreshCart(true);

    ['cart:updated', 'cart:change', 'theme:cart:change'].forEach(function (name) {
      document.addEventListener(name, function () {
        refreshCart(true);
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshCart(true);
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-smp]');
    Array.prototype.forEach.call(roots, function (root) {
      try {
        init(root);
      } catch (err) {
        if (typeof console !== 'undefined' && console.error) {
          console.error('Sewphee product hero init failed', err);
        }
      }
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* Script sits below the section markup — init right away, then again on ready/section load */
  boot();
  onReady(function () {
    boot();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector
      ? event.target.querySelector('[data-smp]')
      : null;
    if (root) {
      root.removeAttribute('data-smp-ready');
      try {
        init(root);
      } catch (err) {
        if (typeof console !== 'undefined' && console.error) console.error(err);
      }
    } else {
      boot(event.target);
    }
  });

  window.SewpheeProductHero = { boot: boot, init: init };
})();
